import * as LZString from 'lz-string';

const LocalStorageService = {
  set(name: string, value: any): void {
    try {
      const jsonString = JSON.stringify(value);
      const compressed = LZString.compress(jsonString);
      localStorage.setItem(name, compressed);
    } catch (error) {
      console.error(`LocalStorage set failed for ${name}:`, error);
      // Fallback: clear some space and retry once
      if (error instanceof DOMException && error.code === 22) {
        try {
          localStorage.clear();
          const jsonString = JSON.stringify(value);
          const compressed = LZString.compress(jsonString);
          localStorage.setItem(name, compressed);
        } catch (retryError) {
          console.error(`LocalStorage retry failed for ${name}:`, retryError);
        }
      }
    }
    return;
  },

  get(name: string): unknown | null {
    try {
      const compressed = localStorage.getItem(name);
      if (!compressed) return null;

      const decompressed = LZString.decompress(compressed);
      if (decompressed) return JSON.parse(decompressed);
      if (compressed) return JSON.parse(compressed);

      return null;
    } catch (error) {
      console.error(`LocalStorage get failed for ${name}:`, error);
      // If decompression fails, try reading as uncompressed (backward compatibility)
      try {
        const item = localStorage.getItem(name);
        return item ? JSON.parse(item) : null;
      } catch (fallbackError) {
        console.error(`LocalStorage fallback get failed for ${name}:`, fallbackError);
        return null;
      }
    }
  },

  delete(name: string): void {
    localStorage.removeItem(name);
    return;
  },

  check(name: string): boolean {
    return localStorage.getItem(name) != null;
  },
};

export default LocalStorageService;
